import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
// import Select from 'react-select';
import Navbar from "../components/Navbar";
// import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { motion } from "framer-motion";
import banner from "../assets/Home/banner2.png";
import bannerHead from "../assets/Home/bannerHeadphone.png";
// import offer1 from "../assets/Home/offer1.png";
// import offer2 from "../assets/Home/offer2.png";
import Slideshow from "../components/Slideshow";
import Footer from "../components/Footer";
import MaintenancePage from "../components/MaintenancePage";
import newcategory from "../assets/categories/newcategory.png";
import audio from "../assets/Home/audio.png";
import storage from "../assets/Home/storage.png";
import charging from "../assets/Home/charging.png";
import watch from "../assets/Home/watches.png";
import vehicle from "../assets/Home/vehicle.png";
import mobile from "../assets/Home/mobile.png";
import branded from "../assets/Home/branded.png";
import computer from "../assets/Home/computer.png";
import other from "../assets/Home/other.png";

import axios from "axios";
import {
  FaHeart,
  FaRegHeart,
  FaStar,
  FaArrowAltCircleRight,
} from "react-icons/fa";
import { ChevronLeft, ChevronRight } from "lucide-react";

function Home() {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [allproducts, setAllProducts] = useState([]);
  const [posterUrls, setPosterUrls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [posterLoadFailed, setPosterLoadFailed] = useState(false);

  const [wishlist, setWishlist] = useState([]);
  const [loadingWishlist, setLoadingWishlist] = useState(true);

  // const [quantities, setQuantities] = useState({});
  const navigate = useNavigate();
  // const [options, setOptions] = useState([]);
  // const [productOptions, setProductOptions] = useState({});
  const customerType = localStorage.getItem("CustomerType");

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;

  const [quantities, setQuantities] = useState({});
  const [selectedVariant, setSelectedVariant] = useState("");

  const ledname = localStorage.getItem("LedName");
  const ledcode = localStorage.getItem("Ledcode");
  const ledemail = localStorage.getItem("LedEmail");

  const [categoryProducts, setCategoryProducts] = useState([]);

  // const handleBlur = (productId) => {
  //     handleAddToCart(productId);
  // };

  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -400, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 400, behavior: "smooth" });
  };

  const handleQuantityChange = (productId, value) => {
    setQuantities((prev) => ({
      ...prev,
      [productId]: value,
    }));
  };

  const handleAddToCart = (productId) => {
    console.log(productId);
    const product =
      products.find((p) => p.ID === productId) ||
      allproducts.find((p) => p.ID === productId);
    console.log(product);

    if (!product) {
      console.error("❌ Product not found for ID:", productId);
      toast.error("Product not found. Please refresh the page.");
      return;
    }

    addToCart(product);
  };

  const addToCart = async (product) => {
    const quantity = quantities[product.ID];

    if (quantity === "" || !/^\d+$/.test(quantity) || Number(quantity) <= 0) {
      toast.error("Please enter a valid quantity");
      return;
    }

    const qtyNumber = Number(quantity);
    const existingData = JSON.parse(localStorage.getItem("productData")) || [];

    // const index = existingData.findIndex((item) => item.id === product.ID);
    const index = existingData.findIndex(
      (item) =>
        item.id === product.ID && item.selectedVariant === selectedVariant
    );

    let quantityDifference = qtyNumber;
    let uniqueCode = generateUniqueCode();
    // let uniqueCode = "0";

    if (index !== -1) {
      const updatedQuantity = existingData[index].quantity + qtyNumber;
      if (updatedQuantity > product.Qty) {
        toast.error(`Total quantity exceeds stock (${product.Qty})`);
        return;
      }

      // Keep old code
      uniqueCode = existingData[index].uniqueCode;

      existingData[index].quantity = updatedQuantity;
    } else {
      if (qtyNumber > product.Qty) {
        toast.error(`Available stock is ${product.Qty}`);
        return;
      }

      existingData.push({
        itemName: product.ItemName,
        id: product.ID,
        mop: product.MOP,
        dp: product.DP,
        ap: product.AP,
        mrp: product.MRP,
        branch: product.Branch,
        realpratetax: product.RealPrateTax,
        quantity: qtyNumber,
        uniqueCode,
        selectedVariant, // Track variant in local storage
      });
    }

    // Save to localStorage
    localStorage.setItem("productData", JSON.stringify(existingData));

    const price = getNumericPrice(product);

    // Send to API
    try {
      const payload = {
        itemId: product.ID,
        uniqueCode, // Use the correct one
        itemName: product.ItemName,
        itemPrice: price,
        quantity: quantityDifference,
        ledname,
        ledcode,
        ledemail: ledemail || "no email",
      };
      console.log("Payload to API:", payload);

      const res = await axios.post(
        `${apiBaseUrl}/cart/add/JAPAN_ACCESORIES`,
        payload
      );

      console.log("API Response:", res.data);

      if (res.data.success) {
        toast.success("Item added to cart");
      } else {
        toast.error("Failed to sync with server");
      }
    } catch (err) {
      // console.error("Add to cart error:", err);
      // toast.error("Server error: unable to sync cart");
      console.error(
        "Add to cart error:",
        err?.response?.data || err.message || err
      );
      toast.error("Server error: unable to sync cart");
    }

    setQuantities((prev) => ({ ...prev, [product.ID]: "" }));
  };

  const generateUniqueCode = () => {
    return (
      Date.now().toString(36) + // Timestamp in base36
      Math.random().toString(36).substring(2, 8).toUpperCase() // Random 6 chars
    );
  };

  const getNumericPrice = (product) => {
    switch (customerType) {
      case "CUSTOMER":
        return product.MOP ?? product.MRP;
      case "AGENT":
        return product.AP ?? product.MRP;
      case "DEALER":
        return product.DP ?? product.MRP;
      case "JS_EMPLOYEE":
      case "TK_EMPLOYEE":
      case "JS_MANAGER":
      case "TK_MANAGER":
        return product.MRP;
      default:
        return product.MRP;
    }
  };

  const offer1 = `${apiLocalUrl}/get-poster`;
  const offer2 = `${apiLocalUrl}/get-logo`;

  const images = [offer1, offer2];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [audioSection, setAudioSection] = useState([]);
  const [storageSection, setStorageSection] = useState([]);
  const [chargingSection, setChargingSection] = useState([]);
  const [watchSection, setWatchSection] = useState([]);
  const [vehicleAccessoriesSection, setVehicleAccessoriesSection] = useState(
    []
  );
  const [mobileSection, setMobileSection] = useState([]);
  const [brandsSection, setBrandsSection] = useState([]);
  const [computerAccessoriesSection, setComputerAccessoriesSection] = useState(
    []
  );
  const [othersSection, setOthersSection] = useState([]);

  const categoryData = [
    {
      title: "AUDIO ACCESSORIES",
      image: audio,
      items: audioSection,
    },
    {
      title: "STORAGE DEVICES",
      image: storage,
      items: storageSection,
    },
    {
      title: "CHARGING ACCESSORIES",
      image: charging,
      items: chargingSection,
    },
    {
      title: "WATCH & ACCESSORIES",
      image: watch,
      items: watchSection,
    },
    {
      title: "VEHICLE ACCESSORIES",
      image: vehicle,
      items: vehicleAccessoriesSection,
    },
    {
      title: "MOBILES ACCESSORIES",
      image: mobile,
      items: mobileSection,
    },
    {
      title: "BRANDED DEVICES",
      image: branded,
      items: brandsSection,
    },
    {
      title: "COMPUTER ACCESSORIES",
      image: computer,
      items: computerAccessoriesSection,
    },
    {
      title: "OTHER ACCESSORIES",
      image: other,
      items: othersSection,
    },
  ];

  useEffect(() => {
    const fetchCategorySections = async () => {
      try {
        const response = await fetch(
          `${apiBaseUrl}/getCategories/JAPAN_ACCESORIES/`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }
        const data = await response.json();

        // AUDIO
        const earphone = data.filter(
          (category) => category.Name && category.Name.includes("EARPHONE")
        );
        const airpods = data.filter(
          (category) => category.Name && category.Name.includes("AIRPODS")
        );
        const bluetoothSpeaker = data.filter(
          (category) =>
            category.Name && category.Name.includes("BLUETOOTH SPEAKER")
        );
        const neckband = data.filter(
          (category) =>
            category.Name && category.Name.includes("WIRELESS NECKBAND")
        );

        // STORAGE
        const memoryCard = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("MEMORY CARD")
        );
        const pendrive = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("PENDRIVE")
        );

        // CHARGING
        const charger = data.filter(
          (category) =>
            category.Name &&
            category.Name.toUpperCase().includes("CHARGER") &&
            !category.Name.includes("CAR")
        );
        // const dataCable = data.filter(
        //     (category) => category.Name && category.Name.toUpperCase().includes("DATA CABLE")
        // );
        const powerBank = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("POWER BANK")
        );
        // const wirelessCharger = data.filter(
        //     (category) => category.Name && category.Name.toUpperCase().includes("WIRELESS CHARGER")
        // );

        // WATCH
        const watch = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("WATCH")
        );
        // const watchStrap = data.filter(
        //     (category) => category.Name && category.Name.toUpperCase().includes("WATCH STRAP")
        // );
        // const watchChargingCable = data.filter(
        //     (category) => category.Name && category.Name.toUpperCase().includes("WATCH CHARGING CABLE")
        // );

        //VEHICLE ACCESSORIES
        const carCharger = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("CAR CHARGER")
        );
        const carPhoneHolder = data.filter(
          (category) =>
            category.Name &&
            category.Name.toUpperCase().includes("CAR PHONE HOLDER")
        );
        const bikeHolder = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("BIKE HOLDER")
        );
        const carAccessories = data.filter(
          (category) =>
            category.Name &&
            category.Name.toUpperCase().includes("CAR ACCESSORIES")
        );

        // MOBILE ACCESSORIES
        const phoneHolder = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("PHONEHOLDER")
        );
        const pouchPremium = data.filter(
          (category) =>
            category.Name &&
            category.Name.toUpperCase().includes("POUCH PREMIUM")
        );
        const pouchTab = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("POUCH TAB")
        );
        const screenProtector = data.filter(
          (category) =>
            category.Name &&
            category.Name.toUpperCase().includes("SCREEN PROTECTOR")
        );

        // BRANDS
        const boat = data.filter(
          (category) => category.Name && category.Name.toUpperCase() === "BOAT"
        );
        const jbl = data.filter(
          (category) => category.Name && category.Name.toUpperCase() === "JBL"
        );

        // COMPUTER ACCESSORIES
        const hubAdapter = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("HUB ADAPTER")
        );

        const computerAccessories = data.filter(
          (category) =>
            category.Name &&
            category.Name.toUpperCase().includes("CAMPUTER ACCESSORIES")
        );
        const dataCable = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("DATA CABLE")
        );

        // OTHERS
        const otg = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("OTG")
        );

        const convert = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("CONVERT")
        );
        const powerbank = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("POWERBANK")
        );
        const battery = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("BATTERY")
        );
        const stylusPen = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("STYLUS PEN")
        );
        const camera = data.filter(
          (category) =>
            category.Name && category.Name.toUpperCase().includes("CAMERA")
        );

        setAudioSection([
          ...earphone.slice(0, 4),
          ...airpods.slice(0, 4),
          ...bluetoothSpeaker.slice(0, 4),
          ...neckband.slice(0, 4),
        ]);
        setStorageSection([...memoryCard.slice(0, 4), ...pendrive.slice(0, 4)]);
        setChargingSection([
          ...charger.slice(0, 4),
          // ...dataCable.slice(0, 4),
          ...powerBank.slice(0, 4),
          // ...wirelessCharger.slice(0, 4),
        ]);
        setWatchSection([
          ...watch.slice(0, 4),
          // ...watchStrap.slice(0, 4),
          // ...watchChargingCable.slice(0, 4)
        ]);
        setVehicleAccessoriesSection([
          ...carCharger.slice(0, 4),
          ...carPhoneHolder.slice(0, 4),
          ...bikeHolder.slice(0, 4),
          ...carAccessories.slice(0, 4),
        ]);
        setMobileSection([
          ...phoneHolder.slice(0, 4),
          ...pouchPremium.slice(0, 4),
          ...pouchTab.slice(0, 4),
          ...screenProtector.slice(0, 4),
        ]);
        setBrandsSection([...boat.slice(0, 4), ...jbl.slice(0, 4)]);
        setComputerAccessoriesSection([
          ...hubAdapter.slice(0, 4),
          // ...stylusPen.slice(0, 4),
          // ...camera.slice(0, 4),
          ...computerAccessories.slice(0, 4),
          ...dataCable.slice(0, 4),
        ]);
        setOthersSection([
          ...otg.slice(0, 4),
          ...convert.slice(0, 4),
          ...powerbank.slice(0, 4),
          ...battery.slice(0, 4),
          ...stylusPen.slice(0, 4),
          // ...camera.slice(0, 4),
        ]);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategorySections();
  }, [apiBaseUrl]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          `${apiBaseUrl}/getCategories/JAPAN_ACCESORIES`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch categories");
        }

        const data = await response.json();

        const isMobile = window.innerWidth < 768;

        const categoriesToSet = isMobile
          ? data // on mobile
          : data
              .filter(
                (category) => category.Name && !category.Name.includes(" ")
              )
              .slice(0, 10); // on desktop

        setCategories(categoriesToSet);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, [apiBaseUrl]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          `${apiBaseUrl}/getProductByCategory/JAPAN_ACCESORIES?Id=691`
        );
        const data = await response.json();
        setProducts(data.slice(0, 8));
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, [apiBaseUrl]);

  const [currentIndexes, setCurrentIndexes] = useState({}); // store index per category

  useEffect(() => {
    const fetchAllCategoriesProducts = async () => {
      try {
        const categoriesRes = await fetch(
          `${apiBaseUrl}/getCategories/JAPAN_ACCESORIES`
        );
        const categories = await categoriesRes.json();

        if (!Array.isArray(categories)) {
          console.error("Expected array of categories, got:", categories);
          return;
        }

        const categoryProductsPromises = categories.map(async (cat) => {
          const res = await fetch(
            `${apiBaseUrl}/getProductByCategory/JAPAN_ACCESORIES?Id=${cat.Id}`
          );
          const products = await res.json();

          return {
            categoryId: cat.Id,
            categoryName: cat.Name,
            products: products.slice(0, 10),
          };
        });

        const categoriesWithProducts = await Promise.all(
          categoryProductsPromises
        );

        // initialize indexes (all start at 0)
        const initialIndexes = {};
        categoriesWithProducts.forEach((cat) => {
          initialIndexes[cat.categoryId] = 0;
        });

        setCategoryProducts(categoriesWithProducts);
        setCurrentIndexes(initialIndexes);
      } catch (error) {
        console.error("Error fetching category products:", error);
      }
    };

    fetchAllCategoriesProducts();
  }, [apiBaseUrl]);

  // Slideshow effect for all categories
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndexes((prev) => {
        const updated = { ...prev };
        categoryProducts.forEach((cat) => {
          updated[cat.categoryId] =
            prev[cat.categoryId] === cat.products.length - 1
              ? 0
              : prev[cat.categoryId] + 1;
        });
        return updated;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [categoryProducts]);

  useEffect(() => {
    const fetchProductsBySavedCategory = async () => {
      try {
        // Step 1: Get saved category id
        const savedCategoryRes = await fetch(
          `${apiBaseUrl}/getSavedCategory/JAPAN_ACCESORIES`
        );
        const savedCategory = await savedCategoryRes.json();

        if (!savedCategory || !savedCategory.CategoryId) {
          console.warn("No saved category found");
          return;
        }

        const categoryId = savedCategory.CategoryId;

        // Step 2: Fetch products using saved category id
        const response = await fetch(
          `${apiBaseUrl}/getProductByCategory/JAPAN_ACCESORIES?Id=${categoryId}`
        );
        const data = await response.json();

        // Step 3: Pick 8 middle items
        const middleStartIndex = Math.max(0, Math.floor((data.length - 8) / 2));
        const middleItems = data.slice(middleStartIndex, middleStartIndex + 8);

        setAllProducts(middleItems);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProductsBySavedCategory();
  }, [apiBaseUrl]);

  const category = async () => {
    navigate("/categories");
  };

  const items = (id, Name) => {
    navigate("/items", { state: { categoryId: id, Name, category: "HOME" } });
  };

  const newarrival = (id, Name) => {
    navigate("/items", {
      state: { categoryId: 691, Name: "NEW ARRIVAL", category: "HOME" },
    });
  };

  const fullimage = (itemId, ID, customerType) => {
    navigate(`/fullimage/${itemId}/${ID}/${customerType}`);
  };

  const allproduct = async () => {
    navigate("/allproducts", { state: { cutitemId: "" } });
  };

  // const categoryImageMapping = {
  //     685: charger,
  //     686: neckband,
  //     687: jbl,
  //     688: airpods,
  // };

  // const Ledcode = sessionStorage.getItem("Ledcode");

  // if (Ledcode === 0 || Ledcode === null || Ledcode === undefined) {
  //     // Return back from the page or perform any desired action
  //     window.history.back();
  // }

  useEffect(() => {
    const fetchWishlist = async () => {
      const ledcode = localStorage.getItem("Ledcode");
      try {
        const res = await axios.get(
          `${apiBaseUrl}/wishlist/items/JAPAN_ACCESORIES/${ledcode}`
        );
        if (res.data.success && Array.isArray(res.data.items)) {
          setWishlist(res.data.items);
        }
      } catch (err) {
        console.error("Fetch wishlist error:", err);
      } finally {
        setLoadingWishlist(false); // Important!
      }
    };

    fetchWishlist();
  }, [apiBaseUrl]);

  useEffect(() => {
    const fetchPosters = async () => {
      try {
        setPosterLoadFailed(false);
        const response = await axios.get(`${apiLocalUrl}/list-posters`);
        const posters = response.data.posters || [];

        // Create image URLs with cache busting
        const urls = posters.map((poster, index) => ({
          url: `${apiLocalUrl}/posters/poster${
            poster.id
          }/poster.jpg?t=${Date.now()}`,
          alt: `poster-${index}`,
        }));

        setPosterUrls(urls);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching posters:", err);
        setPosterLoadFailed(true);
        setLoading(false);
      }
    };

    fetchPosters();
  }, [apiLocalUrl]);

  if (loading)
    return <div className="text-center py-8">Loading posters...</div>;
  if (posterLoadFailed) return <MaintenancePage />;
  if (posterUrls.length === 0)
    return <div className="text-center py-8">No posters available</div>;

  const renderPriceInfo = (product) => {
    if (!customerType) {
      return <span id="h3">MRP: ₹ {product.MRP}</span>;
    }

    switch (customerType) {
      case "CUSTOMER":
        return (
          <div className="flex flex-row justify-between items-center w-full gap-2">
            <div>
              <div id="h3">MOP: ₹ {product.MOP}</div>
              <div id="h3">MRP: ₹ {product.MRP}</div>
            </div>
            {/* <div>
                            <span className="text-[#d1d5db] font-normal text-sm">₹ </span>
                            <span className="text-[#d1d5db] line-through font-normal text-sm">{product.MRP}</span>
                        </div> */}
          </div>
        );
      case "AGENT":
        return (
          <div className="flex flex-row justify-between items-center w-full gap-2">
            <div>
              <div id="h3">AP: ₹ {product.AP}</div>
              <div id="h3">MOP: ₹ {product.MOP}</div>
            </div>

            <div id="h3">MRP: ₹ {product.MRP}</div>
          </div>
        );
      case "DEALER":
        // return <span id="h3">DP: ₹ {product.DP}</span>;
        return (
          <div className="flex flex-row justify-between items-center w-full gap-2">
            <div>
              <div id="h3">DP: ₹ {product.DP}</div>
              <div id="h3">MOP: ₹ {product.MOP}</div>
            </div>

            <div id="h3">MRP: ₹ {product.MRP}</div>
          </div>
        );
      case "JS_EMPLOYEE":
      case "TK_EMPLOYEE":
        return (
          <div className="flex flex-row justify-between items-center w-full gap-2">
            <div>
              <div id="h3">Branch: {product.Branch}</div>
              <div id="h3">MRP: ₹ {product.MRP}</div>
            </div>
          </div>
        );
      case "JS_MANAGER":
      case "TK_MANAGER":
        return (
          <div className="flex flex-row justify-between items-center w-full gap-2">
            <div>
              <div id="h3">Rate: ₹{product.RealPrateTax}</div>
              <div id="h3">MRP: ₹ {product.MRP}</div>
            </div>
          </div>
        );
      default:
        return (
          <div className="flex flex-row justify-between items-center w-full gap-2">
            {/* <span id="h3">MOP: ₹ {product.MOP}</span>
                        &nbsp;&nbsp;&nbsp;&nbsp; */}
            <div id="h3">MRP: ₹ {product.MRP}</div>
          </div>
        );
    }
  };

  const getPriceByCustomerType = (product) => {
    const customerType = localStorage.getItem("CustomerType");

    switch (customerType) {
      case "CUSTOMER":
        return product.MOP;
      case "AGENT":
        return product.AP;
      case "DEALER":
        return product.DP;
      case "JS_MANAGER":
      case "TK_MANAGER":
        return product.RealPrateTax;
      case "JS_EMPLOYEE":
      case "TK_EMPLOYEE":
        return product.MRP;
      default:
        return product.MRP;
    }
  };

  const addToWishlist = async (product) => {
    const ledcode = localStorage.getItem("Ledcode");
    const price = getPriceByCustomerType(product);
    const payload = {
      ID: product.ID,
      ItemName: product.ItemName,
      MRP: price,
      ledcode: ledcode,
      Qty: 1,
      uniqueCode: 0,
    };

    try {
      const res = await axios.post(
        `${apiBaseUrl}/wishlist/add/JAPAN_ACCESORIES`,
        payload
      );

      if (res.data.success) {
        const newItem = {
          ID: product.ID,
          ItemName: product.ItemName,
          MRP: price,
          ledcode,
          Qty: 1,
          uniqueCode: 0,
        };
        setWishlist((prev) => [...prev, newItem]);

        toast.success("Added to wishlist");
        console.log(wishlist);
      } else {
        toast.error("Failed to add to wishlist");
      }
    } catch (err) {
      console.error("Add to wishlist error:", err);
      toast.error("Error adding to wishlist");
    }
  };

  const removeFromWishlist = async (productId) => {
    try {
      const res = await axios.delete(
        `${apiBaseUrl}/wishlist/delete/JAPAN_ACCESORIES/${productId}`
      );

      if (res.data.success) {
        setWishlist((prev) => prev.filter((item) => item.ID !== productId)); // Remove from local state
        toast.info("Removed from wishlist");
      } else {
        toast.error("Failed to remove from wishlist");
      }
    } catch (err) {
      console.error("Remove wishlist error:", err);
      toast.error("Error removing from wishlist");
    }
  };

  const toggleWishlist = async (product) => {
    const isInWishlist = wishlist.some((item) => item.ID === product.ID);
    if (isInWishlist) {
      await removeFromWishlist(product.ID);
    } else {
      await addToWishlist(product);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#F7F7F7]">
      <div className="sticky top-0 z-50">
        <Navbar />
      </div>

      {/* /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
      <div className="w-full px-4 sm:px-28 py-6 ">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl sm:text-2xl font-bold">Popular Categories</h2>
          <span
            className=" md:block hidden text-sm font-[500] border-b-2 cursor-pointer "
            onClick={category}
          >
            View all
          </span>
          <span className="md:hidden text-sm font-[500] cursor-pointer">
            Swipe for more {">"}
          </span>
        </div>

        <div className="relative">
          {/* Left arrow */}
          <div className=" md:hidden absolute left-0 p-2 top-1/2 -translate-y-1/2 bg-white rounded-full shadow-md w-10 h-10 items-center justify-center cursor-pointer z-10">
            <ChevronLeft />
          </div>

          <div
            className="md:grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-10 gap-y-6 gap-x-4 mx-auto justify-items-center 
                flex md:flex-none overflow-x-auto scrollbar-hide space-x-4 px-2"
          >
            {categories.map((category) => (
              <div
                onClick={() => items(category.Id, category.Name, "Home")}
                key={category.ItemName}
                className="flex flex-col items-center min-w-[96px] flex-shrink-0"
              >
                <div className="bg-[#EDEDF2] rounded-full w-24 h-24 flex items-center justify-center overflow-hidden cursor-pointer">
                  <img
                    src={`${apiLocalUrl}/category-image/${category.Id}`}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = newcategory;
                    }}
                    alt={category.Name}
                    className="object-fill p-2 w-full h-full rounded-full"
                  />
                </div>
                <span className="mt-2 text-sm font-semibold text-center">
                  {category.Name}
                </span>
              </div>
            ))}
          </div>

          {/* Right arrow */}
          <div className=" md:hidden absolute right-0 top-1/2 -translate-y-1/2 p-2 bg-[white] rounded-full shadow-md w-10 h-10 items-center justify-center cursor-pointer z-10">
            <ChevronRight />
          </div>
        </div>
      </div>
      {/* /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

      <div className="flex justify-center items-center h-[200px] sm:h-[300px] md:h-[450px] lg:h-[500px] w-full lg:px-[7%] px-[2%]">
        <div className="flex justify-center items-center h-[75%] w-full">
          <Slideshow images={posterUrls} />
        </div>
      </div>
      {/* <div className=" w-full h-auto flex flex-col justify-center items-center lg:px-[7%] px-[2%]">
                <div className="w-full mb-6 flex flex-row justify-between items-center">
                    <div className="flex-grow flex items-center lg:justify-center justify-start">
                        <h2 className="lg:text-xl font-display font-[700] border-b-2 border-black">CATEGORIES</h2>
                    </div>
                    <span className="text-xs font-[500] border-b-2 cursor-pointer " onClick={category}>
                        See more
                    </span>
                </div>
            </div> */}

      {/* <h2>NEW DESIGN</h2> */}

      {/* /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}
      {/* <div className="w-full px-4 sm:px-28 py-6 ">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl sm:text-2xl font-bold">Popular Categories</h2>
                    <a href="#" className="text-xs font-[500] border-b-2 cursor-pointer ">
                        View All
                    </a>
                </div>

                <div className="grid grid-cols-4  gap-y-6 gap-x-4 justify-items-center">
                    {categories.map((category) => (
                        <div
                            onClick={() => items(category.Id, category.Name, "Home")}
                            key={category.ItemName}
                            className="flex flex-col items-center"
                        >
                            <div className="bg-[#EDEDF2] rounded-full w-24 h-24 flex items-center justify-center overflow-hidden">
                                <img
                                    src={`${apiLocalUrl}/category-image/${category.Id}`}
                                    onError={(e) => {
                                        e.target.onerror = null; // Prevent infinite loop
                                        e.target.src = newcategory;
                                    }}
                                    alt={category.Name}
                                    className="object-contain h-14"
                                />
                            </div>
                            <span className="mt-2 text-sm font-semibold">{category.Name}</span>
                        </div>
                    ))}
                </div>
            </div> */}

      {/* /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

      <div className="w-full px-4 sm:px-28 py-6 ">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl sm:text-2xl font-bold">Latest Collections</h2>
          <span
            className="text-sm font-[500] border-b-2 cursor-pointer "
            onClick={() => newarrival(691, "NEW ARRIVAL", "HOME")}
          >
            See more
          </span>
        </div>

        {/* <h2>OLD DESIGN</h2> */}

        {/* <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 w-full mt-2 gap-x-4">
                    {products.map((product, index) => (
                        <div key={product.ID} className="product-card w-full h-80 flex flex-col ">
                             Image Box with group for hover effect 
                            <div
                                onClick={() => fullimage(product.ItemName, product.ID, customerType)}
                                className="relative group w-full lg:h-[313px] md:h-[270px] sm:h-[250px] h-[200px] flex flex-col justify-center items-center bg-[white] rounded-[10px] cursor-pointer overflow-hidden"
                            >
                                <div className="w-[68%] h-[68%] flex justify-center items-center">
                                    <img
                                        src={`${apiLocalUrl}/uploads/${product.ID}.jpg?v=${Date.now()}`}
                                        alt={product.ItemName}
                                        className="size-[90%] object-contain mix-blend-multiply"
                                    />
                                </div>

                                 Add to Cart Button: only on hover 
                                <div className="absolute bottom-0 w-full bg-[black] text-[white] p-2 text-sm font-semibold text-center  opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                    🛒 Add to Cart
                                </div>
                            </div>

                             Product Details 
                            <div className="w-full md:h-[20vh] h-auto flex flex-col  items-start py-2 gap-1 px-2">
                                <span className="lg:text-base sm:text-sm text-xs font-display text-left w-full">
                                    {product.ItemName}
                                </span>

                                <div className="flex flex-row justify-between items-center w-full gap-2">
                                    <span className="lg:text-lg sm:text-sm text-xs font-display text-left w-full">
                                        {customerType === "AGENT" && <span>AP: {product.AP}</span>}
                                        {customerType === "DEALER" && <span>DP: {product.DP}</span>}
                                        {(customerType === "JS_EMPLOYEE" || customerType === "TK_EMPLOYEE") && (
                                            <span>
                                                Branch: {product.Branch} &nbsp;&nbsp;&nbsp; MRP: {product.MRP}
                                            </span>
                                        )}
                                        {(customerType === "JS_MANAGER" || customerType === "TK_MANAGER") && (
                                            <span>
                                                Rate: {product.RealPrateTax} &nbsp;&nbsp;&nbsp; MRP: {product.MRP}
                                            </span>
                                        )}
                                        {customerType !== "JS_EMPLOYEE" &&
                                            customerType !== "JS_MANAGER" &&
                                            customerType !== "TK_MANAGER" &&
                                            customerType !== "TK_EMPLOYEE" && (
                                                <span>
                                                    MOP: {product.MOP} &nbsp;&nbsp;&nbsp; MRP: {product.MRP}
                                                </span>
                                            )}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div> */}

        {/* <h2>NEW DESIGN</h2> */}

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 w-full mt-5">
          {products.map((product, index) => (
            <div
              key={product.ID}
              className="product-card w-full flex flex-col gap-1  rounded-md mb-4  border-[#d1d5db] bg-[white]"
            >
              <div
                key={product.ID}
                className="relative group w-full lg:h-[313px] md:h-[270px] sm:h-[250px] h-[200px] flex flex-col justify-center items-center bg-[white] gap-[2%] cursor-pointer overflow-hidden"
              >
                {/* Wishlist Button */}
                {!loadingWishlist && customerType === "CUSTOMER" && (
                  <button
                    className="absolute top-3 right-3 text-[#d1d5db] hover:text-[red]"
                    onClick={() => toggleWishlist(product)}
                  >
                    {wishlist.some((item) => item.ID === product.ID) ? (
                      <FaHeart size={20} className="text-[red]" />
                    ) : (
                      <FaRegHeart size={20} />
                    )}
                  </button>
                )}

                {/* Product Image */}
                <div
                  onClick={() =>
                    fullimage(product.ItemName, product.ID, customerType)
                  }
                  className="w-[68%] h-[68%] flex justify-center items-center"
                >
                  <img
                    src={`${apiLocalUrl}/uploads/${
                      product.ID
                    }.jpg?v=${Date.now()}`}
                    alt={product.ItemName}
                    className="size-[90%] object-contain mix-blend-multiply"
                  />
                </div>

                {/* Add to Cart Section */}

                <div className=" w-full text-center">
                  {customerType !== "AGENT" && (
                    <div className="mx-4 bg-gradient-to-r from-[#8b0000] to-[#d78e8e] rounded text-[white] p-2 flex items-center justify-center">
                      <div className="flex">
                        <span className="text-lg font-medium">🛒</span>
                        <span className=" hidden md:flex lg:text-md sm:text-sm text-xs font-medium items-center">
                          Add to Cart
                        </span>
                      </div>

                      <input
                        type="text"
                        min="1"
                        value={quantities[product.ID] || ""}
                        onChange={(e) =>
                          handleQuantityChange(product.ID, e.target.value)
                        }
                        // onBlur={() => handleBlur(product.ID)}
                        className="md:w-12 w-10 px-1 py-0.5 text-[black] rounded  mx-1 lg:text-md sm:text-sm text-xs font-medium"
                      />
                      <span
                        role="button"
                        onClick={() => handleAddToCart(product.ID)}
                        className="cursor-pointer hover:underline"
                      >
                        <FaArrowAltCircleRight className="md:size-6 size-5" />
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div
                onClick={() =>
                  fullimage(product.ItemName, product.ID, customerType)
                }
                className="w-full md:h-[18vh] h-auto flex flex-col items-start py-2 gap-1 px-4 rounded-b-[10px] bg-[white]"
              >
                {/* <p className="text-sm text-[#a4a7ab] mb-1">Category</p> */}
                <span className="lg:text-md sm:text-sm text-xs font-medium text-left w-[70%]">
                  {product.ItemName}
                </span>
                {/* Rating */}
                {/* <div className="flex gap-1 ">
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar key={i} className="text-[#FACC15] text-sm" />
                                    ))}
                                </div> */}

                <div className="flex flex-row justify-between items-center w-full gap-2">
                  <span className="lg:text-md sm:text-sm text-xs text-[#2563EB] font-semibold text-left w-full">
                    {renderPriceInfo(product)}
                  </span>
                  {/* <span className="text-[#d1d5db] text-sm">₹</span> */}
                  {/* <span className="text-[#d1d5db] line-through text-sm">{product.MRP}</span> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* <div className="flex justify-center items-center h-[200px] sm:h-[300px]  md:h-[450px] lg:h-[500px] w-full lg:px-[7%] px-[2%]">
                <div className="flex justify-center items-center h-[75%] w-full">
                    <Slideshow images={images} />
                </div>
            </div> */}

      <div className="w-full px-4 sm:px-28 py-6 ">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl sm:text-2xl font-bold">All Products</h2>
          <span
            className="text-sm font-[500]  border-b-2 cursor-pointer "
            onClick={allproduct}
          >
            See more
          </span>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4 w-full mt-5">
          {allproducts.map((product, index) => (
            <div
              key={product.ID}
              className="product-card w-full flex flex-col gap-1  rounded-md mb-4  border-[#d1d5db] bg-[white]"
            >
              <div className="relative group w-full lg:h-[313px] md:h-[270px] sm:h-[250px] h-[200px] flex flex-col justify-center items-center bg-[white] rounded-[10px] gap-[2%] cursor-pointer overflow-hidden ">
                {!loadingWishlist && customerType === "CUSTOMER" && (
                  <button
                    className="absolute top-3 right-3 text-[#d1d5db] hover:text-[red]"
                    onClick={() => toggleWishlist(product)}
                  >
                    {wishlist.some((item) => item.ID === product.ID) ? (
                      <FaHeart size={20} className="text-[red]" />
                    ) : (
                      <FaRegHeart size={20} />
                    )}
                  </button>
                )}

                <div
                  onClick={() =>
                    fullimage(product.ItemName, product.ID, customerType)
                  }
                  className="w-[68%] h-[68%] flex justify-center items-center "
                >
                  <img
                    src={`${apiLocalUrl}/uploads/${
                      product.ID
                    }.jpg?v=${Date.now()}`}
                    alt="carcharger"
                    className="size-[90%] object-contain mix-blend-multiply"
                  />
                </div>

                {/* Add to Cart Section */}

                <div className=" w-full text-center">
                  {customerType !== "AGENT" && (
                    <div className="mx-4 bg-gradient-to-r from-[#8b0000] to-[#d78e8e] rounded text-[white] p-2 flex items-center justify-center">
                      <div className="flex">
                        <span className="text-lg font-medium">🛒</span>
                        <span className=" hidden md:flex lg:text-md sm:text-sm text-xs font-medium items-center">
                          Add to Cart
                        </span>
                      </div>

                      <input
                        type="text"
                        min="1"
                        value={quantities[product.ID] || ""}
                        onChange={(e) =>
                          handleQuantityChange(product.ID, e.target.value)
                        }
                        // onBlur={() => handleBlur(product.ID)}
                        className="md:w-12 w-10 px-1 py-0.5 text-[black] rounded  mx-1 lg:text-md sm:text-sm text-xs font-medium"
                      />
                      <span
                        role="button"
                        onClick={() => handleAddToCart(product.ID)}
                        className="cursor-pointer hover:underline"
                      >
                        <FaArrowAltCircleRight className="md:size-6 size-5" />
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div
                onClick={() =>
                  fullimage(product.ItemName, product.ID, customerType)
                }
                className="w-full md:h-[18vh] h-auto flex flex-col items-start py-2 gap-1 px-4 rounded-b-[10px] bg-[white]"
              >
                {/* <p className="text-sm text-[#a4a7ab] mb-1">Category</p> */}
                <span className="lg:text-md sm:text-sm text-xs font-medium text-left w-[70%]">
                  {product.ItemName}
                </span>
                {/* Rating */}
                {/* <div className="flex gap-1">
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar key={i} className="text-[#FACC15] text-sm" />
                                    ))}
                                </div> */}

                <div className="flex flex-row justify-between items-center w-full gap-2">
                  <span className="lg:text-md sm:text-sm text-xs text-[#2563EB] font-semibold text-left w-full">
                    {renderPriceInfo(product)}
                  </span>
                  {/* <span className="text-[#d1d5db] text-sm">₹</span> */}
                  {/* <span className="text-[#d1d5db] line-through text-sm">{product.MRP}</span> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* <div className="flex justify-center items-center h-[200px] sm:h-[300px] md:h-[450px] lg:h-[500px] w-full lg:px-[7%] px-[2%]">
                <div className="flex justify-center items-center h-[75%] w-full">
                    <Slideshow images={images} />
                </div>
            </div> */}

      {/* <div className="flex overflow-x-auto gap-14 px-4 md:px-12 py-10 mx-4 md:mx-16 scrollbar-hide">
                {categoryData.map((category, index) => (
                    <div key={index} className="bg-[white] p-4 rounded-lg w-[330px] md:min-w-[450px] flex-shrink-0">

                        <div className="flex justify-between items-center mb-4">
                            <h2 className="font-bold tracking-wide">{category.title}</h2>
                        </div>

                        <div className="mb-4">
                            <img src={category.image} alt={category.title} className="rounded-xl w-full object-cover" />
                        </div>

                        <hr className="mb-4 text-[#dfe2e8]" />

                        <div className="grid grid-cols-2 gap-4">
                            {category.items.map((item, idx) => {
                                // Get products for this category item
                                const itemProducts = categoryProducts.find((c) => c.categoryId === item.Id)?.products || [];

                                return (
                                    <div key={idx} className="flex flex-col items-center text-center gap-1">
                                        <div
                                            className="w-24 h-24 rounded-full bg-[#dfe2e8] flex items-center justify-center overflow-hidden relative cursor-pointer"
                                            onClick={() => items(item.Id, item.Name, "Home")}
                                        >
                                            {itemProducts.map((product, index) => (
                                                <div
                                                    key={product.ID}
                                                    className={`absolute inset-0 transition-opacity duration-1000 ${
                                                        index === currentIndexes[item.Id]
                                                            ? "opacity-100 z-10"
                                                            : "opacity-0 z-0 pointer-events-none"
                                                    }`}
                                                >
                                                    <img
                                                        src={`${apiLocalUrl}/uploads/${product.ID}.jpg?v=${Date.now()}`}
                                                        alt={product.ItemName}
                                                        className="w-full h-full object-fill p-2 rounded-full"
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                        <span className="font-semibold text-sm cursor-pointer mt-1">{item.Name}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ))}
            </div> */}

      <div className="relative ">
        {/* Left Button */}
        <button
          onClick={scrollLeft}
          className="hidden md:flex absolute left-16 top-1/2 -translate-y-1/2 bg-white shadow-md rounded-full p-2 z-20"
        >
          <ChevronLeft className="w-6 h-6" />
        </button>

        {/* Scrollable Categories */}
        <div
          ref={scrollRef}
          className="flex overflow-x-auto gap-14 px-4 md:px-12 py-10 mx-4 md:mx-16 scrollbar-hide scroll-smooth"
        >
          {categoryData.map((category, index) => (
            <div
              key={index}
              className="bg-[white] p-4 rounded-lg w-[330px] md:min-w-[450px] flex-shrink-0"
            >
              {/* Header */}
              <div className="flex justify-between items-center mb-4">
                <h2 className="font-bold tracking-wide">{category.title}</h2>
              </div>

              {/* Banner Image */}
              <div className="mb-4">
                <img
                  src={category.image}
                  alt={category.title}
                  className="rounded-xl w-full object-cover"
                />
              </div>

              <hr className="mb-4 text-[#dfe2e8]" />

              {/* Items Grid with fading slides */}
              <div className="grid grid-cols-2 gap-4">
                {category.items.map((item, idx) => {
                  const itemProducts =
                    categoryProducts.find((c) => c.categoryId === item.Id)
                      ?.products || [];

                  return (
                    <div
                      key={idx}
                      className="flex flex-col items-center text-center gap-1"
                    >
                      <div
                        className="w-24 h-24 rounded-full bg-[#dfe2e8] flex items-center justify-center overflow-hidden relative cursor-pointer"
                        onClick={() => items(item.Id, item.Name, "Home")}
                      >
                        {itemProducts.map((product, index) => (
                          <div
                            key={product.ID}
                            className={`absolute inset-0 transition-opacity duration-1000 ${
                              index === currentIndexes[item.Id]
                                ? "opacity-100 z-10"
                                : "opacity-0 z-0 pointer-events-none"
                            }`}
                          >
                            <img
                              src={`${apiLocalUrl}/uploads/${
                                product.ID
                              }.jpg?v=${Date.now()}`}
                              alt={product.ItemName}
                              className="w-full h-full object-fill p-2 rounded-full"
                            />
                          </div>
                        ))}
                      </div>
                      <span className="font-semibold text-sm cursor-pointer mt-1">
                        {item.Name}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Right Button */}
        <button
          onClick={scrollRight}
          className="hidden md:flex absolute right-16 top-1/2 -translate-y-1/2 bg-white shadow-md rounded-full p-2 z-20"
        >
          <ChevronRight className="w-6 h-6" />
        </button>
      </div>

      {/* Subscriber Banner */}
      {/* <div className="bg-[#8B0000] text-[white] py-4 flex  items-center">
                <p className="md:text-lg font-medium md:ml-40 ml-8">
                    <span className="font-bold">Subscribe</span> & Get{" "}
                    <span className="text-[#93C5FD] font-semibold">10% OFF</span> for first order
                </p>
            </div> */}

      <div className="mt-[1%]">
        <Footer />
      </div>
      <ToastContainer autoClose={1500} />
    </div>
  );
}

export default Home;
